module.exports = __webpack_public_path__ + "media/src/images/usr_txt_2-4d9f2827ca0700ce315d795baa89bb77.png";